import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <div className="flex flex-col items-start gap-6 py-16">
      <p className="text-small font-medium uppercase tracking-widest text-cobalt">404</p>
      <h1 className="font-display text-display-l text-ink">This page doesn't exist</h1>
      <p className="max-w-prose text-body-l text-ink-muted">
        The page you're looking for was moved, renamed or never existed.
      </p>
      <Link
        to="/"
        className="inline-flex min-h-[44px] items-center rounded-full bg-cobalt px-7 text-small font-medium text-white transition-colors duration-micro ease-porcelain hover:bg-cobalt-deep"
      >
        Back to home
      </Link>
    </div>
  )
}
